import {createSlice, createAsyncThunk}		from '@reduxjs/toolkit';

import {OrderState, Order}					from './interface';
import actions 								from './orderAction';


const initialState: OrderState = {
	isLoad:    false,
	data:      []
};

export const getOrdersApi = createAsyncThunk('order/getOrdersApi', actions.getOrdersApi);
export const getOrderLimitedApi = createAsyncThunk('order/getOrderLimitedApi', actions.getOrderLimitedApi);
export const putOrderAssignApi = createAsyncThunk('order/putOrdersApi', actions.putOrderAssignApi);
export const postOrderApi = createAsyncThunk('order/postOrdersApi', actions.postOrderApi);

export const Reducer = createSlice({
	name:     'order',
	initialState,
	reducers: {
	},
	extraReducers: (builder) => {
		builder
		// --- GET
		.addCase(getOrdersApi.pending, (state) => {
			state.isLoad = true;
		})
		.addCase(getOrdersApi.fulfilled, (state, action) => {
			return ({
				...state,
				isLoad: false,
				data:   action.payload
			});
		})
		.addCase(getOrderLimitedApi.pending, (state) => {
			state.isLoad = true;
		})
		.addCase(getOrderLimitedApi.fulfilled, (state, action) => {
			return ({
				...state,
				isLoad: false,
				data:   action.payload
			});
		})
		//--- PUT
		.addCase(putOrderAssignApi.fulfilled, (state, action) => {
			if (!action.payload?._id)
				return ({...state, isLoadPut: false});

			const copy: Order[] = state.data.map((order) => {
				if (order && action.payload._id === order._id)
					return {...order, ...action.payload};
				return order;
			});

			return ({
				...state,
				data:      copy,
				isLoadPut: false
			});
		})
		//--- POST
		.addCase(postOrderApi.fulfilled, (state, action) => {
			if (action.payload)
				state.data.push(action.payload);
		});
	}
});

export default Reducer.reducer;
